<template>
  <section id="_art" class="artikel_view_area pt-100 pb-100">
    <div class="container mt-5">
      <!-- START HEADER -->
      <div class="row justify-content-left">
        <div class="col-lg-6">
          <div class="section_title text-left pb-25">
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s">
              <span style="border-top: 5px solid black"> Artikel BERITA</span>
            </h4>
            <h4
              class="title wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s">
              TJSL KAI
            </h4>
            <span
              class="wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.4s">
              <p style="color: black">Artikel & Berita</p>
            </span>
          </div>
        </div>
      </div>
      <!-- END HEADER -->

      <!-- START CONTENT -->
      <div class="row">

        <!-- ARTIKEL LIST -->
        <div class="col-lg-8">
          <div
            class="zoom single_blog blog_2 d-sm-flex wow fadeInUp"
            data-wow-duration="1.3s"
            data-wow-delay="0.2s"
            v-for="(artikel, index) in artikels"
            :key="index"
            @click="setDetailArtikel(artikel.id)">
              <div class="blog_content media-body mt-10 mb-10">
                <div class="row">
                    <div class="col-lg-4">
                      <!-- START IMAGES -->
                      <div v-if="artikel.image_source != ''">
                        <div
                          class="blog_image mb-20"
                          v-html="artikel.image_source"
                        ></div>
                      </div>
                      <div v-else>
                         <img
                            style="max-height: 120%;"
                            :src="'https://api.kai.id/tjsl/file/get-file?key=tjsl/logo_kai_27062022152956.jpg'"
                            alt="foto"
                          />
                      </div>
                      <!-- END IMAGES -->
                    </div>
                    <div class="col-lg-8">
                      <h1 class="label_blog_title">
                        <a class="two-line-overflow">
                          {{ artikel.judul }}
                        </a>
                      </h1>
                      <div class="label_artikel_title col-sm-12">
                        <p>
                          &nbsp;
                          <span
                            ><i class="lni lni-eye"></i>
                            {{ artikel.visitor_count }}</span
                          >
                          &nbsp;
                          &nbsp;
                          <span
                            ><i class="lni lni-calendar"></i>
                            {{ artikel.waktu_buat }}</span
                          >
                          &nbsp;
                        </p>
                      </div>
                      <div class="label_artikel_title col-sm-12">
                        <p style="font-size: 0.9rem;">
                          <span>
                            {{ artikel.intro }}</span>
                          &nbsp;
                        </p>
                      </div>
                    </div>
                  </div>
              </div>
          </div>

          <br>

          <div class="centerBlock">
            <paginate
              v-model="page"
              :page-count=pageCount
              :click-handler="clickCallback"
              :prev-text="'Sebelumnya'"
              :next-text="'Selanjutnya'"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :active-class="'myActiveBtn'"
            >
            </paginate>
          </div>
        </div>


        <!-- ARTIKEL POPULER -->
        <div class="col-lg-4">
          <div class="mt-15" style="background-color: #F06A25; padding:10px">
            <h7 style="color:white;">ARTIKEL TERPOPULER</h7>
          </div>
          <div style="background-color: #F9F9F9; padding:10px">
            <div
              class="zoom single_blog blog_2 d-sm-flex mt-20 wow fadeInUp"
              data-wow-duration="1.3s"
              data-wow-delay="0.2s"
              v-for="(artikel, index) in artikelPopuler"
              :key="index"
              @click="setDetailArtikel(artikel.id)">
                <div class="blog_content media-body mt-10 mb-10">
                  <div class="row">
                      <div class="col-lg-4">
                        <!-- START IMAGES -->
                        <div v-if="artikel.image_source != ''">
                          <div
                            class="blog_image mb-20"
                            v-html="artikel.image_source"
                          ></div>
                        </div>
                        <div v-else>
                          <img
                              style="max-height: 120%;"
                              :src="process.env.VUE_APP_API_BASE_FILE+'/get-file?key=tjsl/logo_kai_27062022152956.jpg'"
                              alt="foto"
                            />
                        </div>
                        <!-- END IMAGES -->
                      </div>
                      <div class="col-lg-8">
                        <h1 class="label_blog_title">
                          <a class="two-line-overflow">
                            {{ artikel.judul }}
                          </a>
                        </h1>
                        <div class="label_artikel_title col-sm-12">
                          <p>
                            &nbsp;
                            <span
                              ><i class="lni lni-eye"></i>
                              {{ artikel.visitor_count }}</span
                            >
                            &nbsp;
                            &nbsp;
                            <span
                              ><i class="lni lni-calendar"></i>
                              {{ artikel.waktu_buat }}</span
                            >
                            &nbsp;
                          </p>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>

      </div>
      <!-- END CONTENT -->
    </div>
  </section>
</template>
<script>
import ArtikelDataService from "../services/ArtikelDataService";
import Paginate from "vuejs-paginate-next";

export default {
  name: "artikelView",
  data() {
    return {
      pageCount: 0, //initial page pagination
      dataPerPage: 6, //for limiting per page
      dataPerPagePopuler: 5,
      artikels: [],
      artikelPopuler: [],
      page: 1
    };
  },
  components: {
    paginate: Paginate,
  },
  methods: {
    getCountAllArtikels() {
      ArtikelDataService.getAll(0, 999999999999999)
        .then((response) => {
          var length = response.data.data.length;
          var divided = length / this.dataPerPage;
          // var page_count = 0;
          // //jika panjang total habis dibagi dataPerPage, maka jumlah page = divided, jika masih ada sisa divided+1
          // if(length % this.dataPerPage === 0){
          //   page_count = divided;
          // }else{
          //   page_count = divided + 1;
          // }
          this.pageCount = Math.ceil(divided);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    clickCallback (pageNum) {
      console.log(pageNum-1);
      this.retrieveArtikels(pageNum-1, this.dataPerPage);
    },

    retrieveArtikels(offset, limit) {
      ArtikelDataService.getAll(offset, limit)
        .then((response) => {
          this.artikels = response.data.data;
          console.log(this.artikels);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    retrieveArtikelPopuler(offset, limit) {
      ArtikelDataService.getAllPopuler(offset, limit)
        .then((response) => {
          this.artikelPopuler = response.data.data;
          console.log(this.artikelPopuler);
        })
        .catch((e) => {
          console.log(e);
        });
    },

    setDetailArtikel(id) {
      this.$router.push({ name: 'detail_article', params: { id: id } })
    },
  },
  mounted() {
    this.getCountAllArtikels();
    this.retrieveArtikels(0, this.dataPerPage);
    this.retrieveArtikelPopuler(0, this.dataPerPagePopuler);
  },
};
</script>

<style>

.label_artikel_title p {
  color: #777777;
  font-size: 8px;
}

.centerBlock {
  display: table;
  margin: auto;
}

.text-overflow-handle {
  white-space: nowrap;
  max-width: 100%;
  height:200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.two-line-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color:#000;
}
</style>
